<script>
  import { inertia, router } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AdminLayout from '../../../components/AdminLayout.svelte';
  import Card from '../../../components/ui/Card.svelte';
  import StatusBadge from '../../../components/StatusBadge.svelte';

  let {
    accounts = [],
    pagination = { page: 1, pages: 1, count: 0 },
  } = $props();

  function goto(page) {
    router.get('/admin/accounts', { page }, { preserveScroll: true });
  }
</script>

<AdminLayout title="Accounts">
  <Card>
    <div class="flex items-center justify-between mb-4">
      <span class="text-sm text-secondary-500">{pagination.count} total</span>
    </div>

    {#if accounts.length === 0}
      <p class="text-secondary-500 text-sm py-4 text-center">No accounts.</p>
    {:else}
      <!-- Stacked cards below sm; table at sm and up (see suggestion #25). -->
      <ul class="flex flex-col divide-y divide-secondary-100 sm:hidden">
        {#each accounts as acc}
          <li class="py-3 first:pt-0 last:pb-0">
            <a use:inertia href={`/admin/accounts/${acc.id}`} class="flex flex-col gap-1.5">
              <div class="flex items-center justify-between gap-2">
                <span class="font-medium text-secondary-800">{acc.email}</span>
                {#if acc.is_admin}
                  <Icon icon="mdi:shield-crown-outline" class="text-amber-500 text-lg shrink-0" />
                {/if}
              </div>
              <div class="flex items-center justify-between gap-2 text-sm text-secondary-500">
                <span>{acc.workspace_name || '—'}</span>
                <StatusBadge status={acc.status} />
              </div>
            </a>
          </li>
        {/each}
      </ul>

      <div class="overflow-x-auto hidden sm:block">
        <table class="w-full text-sm">
          <thead>
            <tr class="text-left text-secondary-400 border-b border-secondary-100">
              <th class="font-medium py-2 pr-4">Email</th>
              <th class="font-medium py-2 pr-4">Workspace</th>
              <th class="font-medium py-2 pr-4">Status</th>
              <th class="font-medium py-2 pr-4">Admin</th>
              <th class="font-medium py-2"></th>
            </tr>
          </thead>
          <tbody class="divide-y divide-secondary-100">
            {#each accounts as acc}
              <tr class="hover:bg-secondary-50">
                <td class="py-3 pr-4 font-medium text-secondary-800">{acc.email}</td>
                <td class="py-3 pr-4 text-secondary-500">{acc.workspace_name || '—'}</td>
                <td class="py-3 pr-4"><StatusBadge status={acc.status} /></td>
                <td class="py-3 pr-4">
                  {#if acc.is_admin}
                    <Icon icon="mdi:shield-crown-outline" class="text-amber-500 text-lg" />
                  {:else}
                    <span class="text-secondary-300">—</span>
                  {/if}
                </td>
                <td class="py-3 text-right">
                  <a use:inertia href={`/admin/accounts/${acc.id}`} class="text-primary-600 hover:text-primary-800">
                    Manage
                  </a>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>

      {#if pagination.pages > 1}
        <div class="flex items-center justify-between mt-4 pt-4 border-t border-secondary-100 text-sm">
          <button
            class="text-secondary-600 hover:text-primary-700 disabled:opacity-30 disabled:pointer-events-none flex items-center gap-1 py-2 px-1 -my-2"
            disabled={pagination.page <= 1}
            aria-label="Previous page"
            onclick={() => goto(pagination.page - 1)}
          >
            <Icon icon="mdi:chevron-left" /> Previous
          </button>
          <span class="text-secondary-400">Page {pagination.page} of {pagination.pages}</span>
          <button
            class="text-secondary-600 hover:text-primary-700 disabled:opacity-30 disabled:pointer-events-none flex items-center gap-1 py-2 px-1 -my-2"
            disabled={pagination.page >= pagination.pages}
            aria-label="Next page"
            onclick={() => goto(pagination.page + 1)}
          >
            Next <Icon icon="mdi:chevron-right" />
          </button>
        </div>
      {/if}
    {/if}
  </Card>
</AdminLayout>
